import styled, { css } from 'styled-components';
const getMaxColumns = ({ $cardStyle, $direction, $size, }) => {
    if ($cardStyle === 'link')
        return $size;
    else if ($direction === 'column')
        return 1;
    else if ($size > 2) {
        if ($size % 3 === 0) {
            return 3;
        }
        else {
            return 2;
        }
    }
    else
        return $size;
};
export const ItemsListStyled = styled.div `
  align-items: stretch;

  flex-direction: ${({ $direction }) => $direction};
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(${(props) => getMaxColumns(props)}, 1fr);
  width: 100%;

  ${({ $cardStyle }) => $cardStyle === 'Showcase'
    ? css `
          gap: 32px;
        `
    : css `
          gap: 24px;
          & > * {
            flex-shrink: 0;
            height: auto;
            width: 100%;
            & > * {
              width: 100%;
              height: 100% !important;
            }
          }
        `}

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
